import { render, staticRenderFns } from "./EntityFact.vue?vue&type=template&id=28968eb5"
import script from "./EntityFact.vue?vue&type=script&lang=js"
export * from "./EntityFact.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports